import { Await, defer, useLoaderData } from "react-router-dom";
import api from "../storage/api";
import { Suspense } from "react";
import Loader from "../components/Modals/Loader";
import ProductsMain from "./ProductsMain";

const ProductsPage = () => {
  const { events } = useLoaderData();

  return (
    <Suspense fallback={<Loader />}>
      <Await resolve={events}>
        {(loadedContent) => {
          return (
            <ProductsMain content={loadedContent} />
          );
        }}
      </Await>
    </Suspense>
  );
};

export default ProductsPage;

async function loadProducts(params) {
  const response = await fetch(api.apiPath + "&path=products&server=" + params.server);

  if (!response.ok) {
    alert("Произошла ошибка при загрузке данных...");
  } else {
    return response.json();
  }
}

export function loader({params}) {
  return defer({
    events: loadProducts(params),
  });
}
